import { render, staticRenderFns } from "./HasGoodWill.vue?vue&type=template&id=2496b28f&"
import script from "./HasGoodWill.vue?vue&type=script&lang=ts&"
export * from "./HasGoodWill.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports